// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip-wrapper {
  position: relative;
  display: inline-block;
}

/* Tooltip box */
.custom-tooltip {
  position: absolute;
  bottom: 120%; 
  left: 50%;
  transform: translateX(-50%);
  padding: 6px 10px;
  font-size: 14px;
  border-radius: 6px;
  white-space: nowrap;
  color: #ffffff;

  /* Glass dark effect */
     background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(30px);
    -webkit-backdrop-filter: blur(30px);
    box-shadow: inset 0 0 4px rgba(116, 121, 255, 0.2);

  opacity: 0;
  pointer-events: none;
  transition: opacity 0.25s ease;
  z-index: 20;
}

/* Show tooltip on hover */
.tooltip-wrapper:hover .custom-tooltip {
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/css/tooltip.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;;EAEd,sBAAsB;KACnB,oCAAoC;IACrC,2BAA2B;IAC3B,mCAAmC;IACnC,kDAAkD;;EAEpD,UAAU;EACV,oBAAoB;EACpB,8BAA8B;EAC9B,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,UAAU;AACZ","sourcesContent":[".tooltip-wrapper {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n/* Tooltip box */\r\n.custom-tooltip {\r\n  position: absolute;\r\n  bottom: 120%; \r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  padding: 6px 10px;\r\n  font-size: 14px;\r\n  border-radius: 6px;\r\n  white-space: nowrap;\r\n  color: #ffffff;\r\n\r\n  /* Glass dark effect */\r\n     background: rgba(255, 255, 255, 0.1);\r\n    backdrop-filter: blur(30px);\r\n    -webkit-backdrop-filter: blur(30px);\r\n    box-shadow: inset 0 0 4px rgba(116, 121, 255, 0.2);\r\n\r\n  opacity: 0;\r\n  pointer-events: none;\r\n  transition: opacity 0.25s ease;\r\n  z-index: 20;\r\n}\r\n\r\n/* Show tooltip on hover */\r\n.tooltip-wrapper:hover .custom-tooltip {\r\n  opacity: 1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
